enum QUESTION_TYPES {
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTIPLE_CHOICES_WITH_OTHER = 'MULTIPLE_CHOICES_WITH_OTHER',
  MULTIPLE_CHOICES_MULTI_SELECT = 'MULTIPLE_CHOICES_MULTI_SELECT',
  TEXT_ANSWER = 'TEXT_ANSWER',
  DATE = 'DATE',
}

export default QUESTION_TYPES;
